"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addExtensions = exports.renderString = exports.renderer = exports.loader = undefined;

var _nunjucks = require("nunjucks");

var _nunjucks2 = _interopRequireDefault(_nunjucks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderer = new _nunjucks2.default.Environment();

/*
* returns the precompiled template with the given name
*
* @param string The name of the precompiled template
*
* @return string
*/
var loader = function loader(name) {
    return window.nunjucksPrecompiled && window.nunjucksPrecompiled[name];
};

/**
* Render a template by name
*
* @param string The name of the template. If you have precompiled templates loaded in the page
* these will be available by name here
* @param object The context data to pass to the template when it is rendered
*
* @return string The rendered template markup
*/
var renderTemplate = function renderTemplate(name, context) {
    return renderer.render(name, context);
};

/**
* Render a template by raw string
*
* @param string The template source to render
* @param object The context data to pass to the template when it is rendered
*
* @return string The rendered template markup
*/
var renderString = function renderString(tpl, context) {
    return renderer.renderString(tpl, context);
};

/**
* Add extensions to the nunjucks env.
*
* @param function An function to accept the nunjucks env, it is responsible for
* adding whatever extensions it wants to add
*/
var addExtensions = function addExtensions(extensionFunc) {
    extensionFunc(renderer);
};

exports.loader = loader;
exports.renderer = renderer;
exports.renderString = renderString;
exports.addExtensions = addExtensions;
exports.default = renderTemplate;